import React from "react";

function parseReceiptSafe(receipt) {
  if (!receipt) return null;

  try {
    const cleaned = receipt.replace(/[\u0000-\u001F]+/g, "");
    let parsed = JSON.parse(cleaned);
    if (typeof parsed === "string") parsed = JSON.parse(parsed);
    return parsed;
  } catch (err) {
    console.error("Failed to parse receipt:", err);
    return null;
  }
}

function downloadReceiptPDF(base64, fileName) {
  try {
    const cleanB64 = base64.replace(/[\r\n]+/g, "");
    const byteCharacters = atob(cleanB64);
    const byteNumbers = Array.from(byteCharacters).map((c) => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to download PDF:", err);
    alert("Errore nel download della ricevuta PDF");
  }
}

const ClackpayPaymentTicket = ({ receiptString }) => {
  const parsed = parseReceiptSafe(receiptString);
  const receiptData =
    parsed?.original?.CreatedPaymentsReceipts?.[0] || null;

  if (!receiptData) {
    return (
      <div style={{ color: "red", fontSize: 12 }}>
        Impossibile leggere i dati della ricevuta
      </div>
    );
  }

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    margin: "20px 0",
    borderBottom: "1px dashed #999",
  };

  const labelStyle = { fontWeight: "bold" };
  const valueStyle = { fontWeight: "500" };
  const linkStyle = {
    color: "#1D4ED8",
    textDecoration: "underline",
    marginTop: 8,
    display: "inline-block",
    cursor: "pointer",
  };

  return (
    <div style={{ fontSize: 14, lineHeight: 1.4 }}>
      <div style={rowStyle}>
        <span style={labelStyle}>Receipt ID:</span>
        <span style={valueStyle}>{receiptData.Id}</span>
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Unique Code:</span>
        <span style={valueStyle}>{receiptData.UniqueCode}</span>
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Execution Date:</span>
        <span style={valueStyle}>
          {receiptData.ExecutionDate &&
            new Date(receiptData.ExecutionDate).toLocaleString("it-IT")}
        </span>
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Currency Date:</span>
        <span style={valueStyle}>
          {receiptData.CurrencyDate &&
            new Date(receiptData.CurrencyDate).toLocaleString("it-IT")}
        </span>
      </div>
      {receiptData.ExternalId && (
        <div style={rowStyle}>
          <span style={labelStyle}>External ID:</span>
          <span style={{ ...valueStyle, wordBreak: "break-all", textAlign: "right" }}>
            {receiptData.ExternalId}
          </span>
        </div>
      )}
      {receiptData.Receipt?.Base64Content && (
        <div
          style={linkStyle}
          onClick={() =>
            downloadReceiptPDF(
              receiptData.Receipt.Base64Content,
              receiptData.Receipt?.Name || "payment_receipt.pdf"
            )
          }
        >
          Apri PDF ricevuta
        </div>
      )}
    </div>
  );
};

export default ClackpayPaymentTicket;
